import { client } from '@/client';
import {
  FalsePositiveIp,
  FalsePositiveIpsResponse,
  UpdateFalsePositiveIpsRequest,
} from '@/client/campaigns/types/false-positive-ips.type';
import { GenericForbiddenApiError } from '@/hooks/query';
import {
  useMutation,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';

const queryKey = 'false-positive-ips';

export const useFalsePositiveIps = (
  params?: UseQueryOptions,
): UseQueryResult<FalsePositiveIpsResponse> & {
  falsePositiveIps: FalsePositiveIpsResponse | undefined;
} => {
  const {
    retry = false,
    retryDelay = 500,
    staleTime = 0,
    cacheTime = 0,
    ...restOptions
  } = params || {};

  const { data, ...rest } = useQuery(
    [queryKey],
    () => client.falsePositiveIps.getFalsePositiveIps(),
    {
      retry,
      retryDelay,
      staleTime,
      cacheTime,
      ...(restOptions as any),
    },
  );

  return {
    falsePositiveIps: data,
    ...(rest as UseQueryResult<FalsePositiveIpsResponse>),
  };
};

export const useUpdateFalsePositiveIpsList = (): {
  update: (payload: UpdateFalsePositiveIpsRequest) => Promise<FalsePositiveIp>;
} & {
  isLoading: boolean;
  error: GenericForbiddenApiError | null;
} => {
  const { mutateAsync, ...rest } = useMutation<
    FalsePositiveIp,
    GenericForbiddenApiError,
    UpdateFalsePositiveIpsRequest
  >('updateFalsePositiveIpsList', (payload: UpdateFalsePositiveIpsRequest) =>
    client.falsePositiveIps.updateFalsePositiveIpsList(payload),
  );

  return { update: mutateAsync, ...(rest as any) };
};
